import { IUser } from "store/types";
import { addCookie, COOKIE_JWT_ACCESS_TOKEN, COOKIE_JWT_ID_TOKEN, decodeToken, getCookie } from "./Cookies";
import { requiredEnvVar } from "./envUtil";
import AppID from "ibmcloud-appid-js";

export const performAuth = async () => {
  // if tokens invalid then force signin
  const accessToken = getCookie(COOKIE_JWT_ACCESS_TOKEN);
  const idToken = getCookie(COOKIE_JWT_ID_TOKEN);
  if (idToken && accessToken) {
    return sanitise({
      idToken: idToken,
      idTokenPayload: decodeToken(idToken),
      accessToken: accessToken,
      accessTokenPayload: decodeToken(accessToken),
    });
  }
  const appID = new AppID();
  await appID.init({
    clientId: requiredEnvVar("APPID_CLIENT_ID"),
    discoveryEndpoint: requiredEnvVar("APPID_DISCOVERY_ENDPOINT"),
    popup: { height: 600, width: 400 },
  });
  try {
    const token = await appID.signin();
    const response = sanitise(token);
    return response;
  } catch (e) {
    // catch if the user closes the popup dialog
    console.log(e);
  }
  return null;
};

export const sanitise = (payload: any) => {
  if (payload === null) {
    return null;
  }

  // students do not have access to Subject Rollover
  if (payload.idTokenPayload.email.split("@")[1].split(".")[0] === "students") {
    return null;
  }

  // store JWT tokens as secure cookies and not in redux
  addCookie(COOKIE_JWT_ACCESS_TOKEN, payload.accessToken, payload.accessTokenPayload.exp);
  addCookie(COOKIE_JWT_ID_TOKEN, payload.idToken, payload.idTokenPayload.exp);

  return { valid: true } as IUser;
};
